import React, { useEffect, useMemo } from 'react';

import Alert from '@material-ui/lab/Alert';
import _ from 'lodash';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { useGlobalSeasonSelectors } from '../../../_store/slices/gff/seasons/globalSeasonSlice';
import {
  getPageViewsStatisticsActions,
  useGetPageViewsStatisticsSelectors
} from '../../../_store/slices/statistics/getPageViewsStatisticsSlice';
import CommonDataGrid from '../../../Components/DataGrid/CommonDataGrid';
import LoadingIndicator from '../../../Components/LoadingIndicator';
import {
  ContentBody,
  ContentContainer,
  ContentHeader
} from '../../../Layout/Content';

const columns = [
  {
    field: 'page',
    headerName: 'Page',
    width: 150,
    editable: false
  },
  {
    field: 'tab',
    headerName: 'Tab',
    width: 150,
    editable: false
  },
  {
    field: 'totalViews',
    headerName: 'Total',
    width: 110,
    editable: false,
    align: 'right',
    headerAlign: 'right'
  },
  ..._.map(_.range(12), (i) => ({
    field: `${i}-month-page-views`,
    valueGetter: (params) =>
      _.get(params, ['row', 'pageViewsByMonth', i + 1], 0),
    headerName: moment(`1970-${i + 1}-1`).format('MMM'),
    width: 110,
    editable: false,
    align: 'right',
    headerAlign: 'right'
  }))
];

const PageViewsStatistics = () => {
  const dispatch = useDispatch();

  const { selectedSeason: seasonYear } = useGlobalSeasonSelectors();

  const { inProgress, errorMessage, response } =
    useGetPageViewsStatisticsSelectors(seasonYear);

  const rows = useMemo(
    () =>
      _.chain(response)
        .map((item) => ({
          ...item,
          id: `${_.get(item, 'page')}-${_.get(item, 'tab')}`
        }))
        .orderBy('id')
        .value(),
    [response]
  );

  useEffect(() => {
    dispatch(getPageViewsStatisticsActions.submit({ seasonYear }));
  }, [dispatch, seasonYear]);

  return (
    <ContentContainer>
      <ContentHeader>
        <span>{`Season ${seasonYear} Users Page Views`}</span>
      </ContentHeader>
      <ContentBody>
        {inProgress && <LoadingIndicator />}
        {!inProgress && errorMessage && (
          <Alert severity="error">{errorMessage}</Alert>
        )}
        {!inProgress && !errorMessage && (
          <CommonDataGrid rows={rows} columns={columns} />
        )}
      </ContentBody>
    </ContentContainer>
  );
};

export default PageViewsStatistics;
